import React from 'react';
import Breadcrumbs from '../../elements/Breadcrumbs';
import { CardsContainer, CabinetsList, CardItem, Price, NextBtn } from './Doctors.style';
import { Skeleton } from '@material-ui/lab';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowBottomIcon from '@material-ui/icons/ArrowDropDown';
import ArrowUpIcon from '@material-ui/icons/ArrowDropUp';
import SimpleCard from '../../elements/SimpleCard';

const Doctors = ({
    serviceName,
    isLoading,
    doctorsList,
    handleClickSpecialisationCard,
    selectedSpecialisation,
    handleClickCabinet,
    selectedCabinet,
    selectedCabinetName,
    isOpenCabinetsList,
    handleClickNextBtn,
}) => {

    if (!isLoading && !doctorsList.length) {
        return <Breadcrumbs pathArr={[{ label: 'Запись на прием' }, { label: 'Нет специалистов' }]} />
    }

    return (
        <>
            <Breadcrumbs pathArr={[{ label: 'Запись на прием' }, { label: serviceName }]} />
            <CardsContainer>
                {isLoading
                    ? <>
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                    </>
                    :
                    doctorsList.map((item, index) => <div key={item.id + index}>
                        <div
                            onClick={() =>
                                handleClickSpecialisationCard(item.id, item.name, item.cabinets)
                            }
                            key={item.id + index}
                        >
                            {item.cabinets
                                ? <CardItem isSelected={selectedSpecialisation === item.id && selectedCabinetName && !isOpenCabinetsList}>
                                    {item.name}
                                    {item.price && item.price?.parseInt() > 0
                                        ? <Price> {item.price / 100} &#8381;</Price>
                                        : <div />
                                    }
                                    {isOpenCabinetsList && selectedSpecialisation === item.id && item.cabinets.length >= 1
                                        ? <ArrowUpIcon />
                                        : <div />
                                    }
                                    {isOpenCabinetsList && selectedSpecialisation === item.id && item.cabinets.length >= 1
                                        ? <CabinetsList>
                                            <List component="nav" aria-label="company list">
                                                {item.cabinets && item.cabinets.map((cabinetItem) =>
                                                    <ListItem
                                                        selected={cabinetItem.oid === selectedCabinet}
                                                        button
                                                        key={cabinetItem.oid + cabinetItem.cabinet_name}
                                                        onClick={() => handleClickCabinet(cabinetItem.oid, cabinetItem.cabinet_name)}
                                                    >
                                                        <ListItemText primary={cabinetItem.cabinet_name} />
                                                    </ListItem>
                                                )}
                                            </List>
                                        </CabinetsList>
                                        : <div />
                                    }
                                    {selectedSpecialisation !== item.id || !isOpenCabinetsList && item.cabinets.length >= 1
                                        ? <ArrowBottomIcon />
                                        : <></>
                                    }
                                </CardItem>
                                : <SimpleCard label={item.name} price={item.price} />
                            }

                        </div>
                    </div>
                    )
                }
            </CardsContainer>
            <NextBtn onClick={handleClickNextBtn}></NextBtn>
        </>
    )
}

export default Doctors;
